(function() {
    'use strict';

    a3_cabin_reports.controller('SignatureModalCtrl', SignatureModalCtrl)
    /**
     * @memberof CabinReports
     * @ngdoc controller
     * @name SignatureModalCtrl
     * @description 
     * Shows Show Signature 
     * @ngInject
     */

    function SignatureModalCtrl($scope, $routeParams, $uibModalInstance, TrainingSessionFactory, FlightSessionFactory, GroundDutyFactory, CrewRouteFactory, CourseFactory, courseId, date, dutyId, dutyNo, dutyDay, confirmationMsg, requiresInstructorSignature, trainees, submitSession, releaseGrading, isReleased, needsAdditionalTraining){
        $scope.close = close;
        $scope.submit = submit;
        $scope.confirm = confirm;
        $scope.confirmSubmit = confirmSubmit;
        $scope.releaseSubmit = releaseSubmit;
        $scope.confirmAircraft = confirmAircraft;

        $scope.errorMessage = "";
        $scope.successMessage = "";
        $scope.responseText = null;
        $scope.responseHasErrors = null;
        $scope.success = false;
        $scope.isLoading = false;
        $scope.withGrading = false;

        $scope.formData = {};
        
        var requiredSignature = requiresInstructorSignature;
        $scope.requiredSignature = requiredSignature;

        $scope.releaseWarning = false;
        $scope.isConfirmed = true;
        $scope.releaseGrading = releaseGrading;
        $scope.finalPendigArVis = [];
        $scope.needsAdditionalTraining = needsAdditionalTraining;

        var isGroundDuty =  false;
        if(dutyId) {
            isGroundDuty = true;
        }

        if(releaseNotSelected()){
            $scope.releaseWarning = true;        
        }
        else if(isGroundDuty && hasPendingAircraftVisits()) {
            $scope.aircraftVisits = true;
        }
        else if(confirmationMsg && isReleased){
            $scope.confirmationMsg = confirmationMsg;
            $scope.isConfirmed = false;
        }
        else{
            if(!requiresInstructorSignature){ //if signature isn't required continue with submit 
                $scope.isLoading = true;
                submit();
            }
        }

        function releaseNotSelected(){
            var allAvailable = !trainees.filter(x => !x.Session.Absent).some(x => !x.AvailableRelease);
            var notReleased = trainees.filter(x =>!x.Session.Absent).some(x => !x.Session.Released);
            return allAvailable && notReleased;
        }

        function hasPendingAircraftVisits() {
            var released = !trainees.filter(x =>!x.Session.Absent).some(x => !x.Session.Released) || $scope.withGrading;
            var pendingVisits = released && trainees.filter(x => !x.Session.Absent).some(x => x.pendingAircrafts && x.pendingAircrafts.length > 0);

            if(pendingVisits){        
                var maxLength = 0;
                trainees.filter(x => !x.Session.Absent).forEach(function(trainee){
                    if(trainee.pendingAircrafts.length > maxLength){
                        var maxList = trainee.pendingAircrafts;
                        maxLength = maxList.length;      
                        $scope.finalPendigArVis = trainee.pendingAircrafts;                                      
                    }               
                });
            }
            return pendingVisits;
        }

        function confirm(){
            $scope.isConfirmed = true;
            if(!requiresInstructorSignature){ //if signature isn't required continue with submit 
                $scope.isLoading = true;
                submit();
            }
        }

        function confirmSubmit(){
            $scope.releaseWarning = false;
            if(isGroundDuty && hasPendingAircraftVisits()){
                $scope.aircraftVisits = true;
            }    
        }

        function confirmAircraft() {
            $scope.aircraftVisits = false;
            if(confirmationMsg){
                $scope.confirmationMsg = confirmationMsg;
                $scope.isConfirmed = false;
            }        
        }

        function releaseSubmit(){
            $scope.withGrading = true;
            $scope.releaseWarning = false;

            if(hasPendingAircraftVisits()){
                $scope.aircraftVisits = true;
            }   
            else if(confirmationMsg){
                $scope.confirmationMsg = confirmationMsg;
                $scope.isConfirmed = false;
            }    
        }

        function submit(){
            $scope.errorMessage = "";
            $scope.successMessage = "";
           
            $scope.isLoading = true;
            $scope.success = false;

            var signaturePassword = $scope.formData.password;
            if(!signaturePassword && requiredSignature){
                $scope.isLoading = false;
                $scope.errorMessage = "Signature is required. Please enter your password.";
            }else{

                submitSession(signaturePassword, $scope.withGrading).then(function(data){
                    $scope.isLoading = false;
                    var errorMessage = data.data.errorMessage;

                    $scope.successMessage = "Training has been submitted."

                    //always show errorMessage even if success is true
                    if(errorMessage && errorMessage.length > 0){
                        $scope.errorMessage = errorMessage;

                        //not Release Trainees
                        var responseTrainees = data.data.data.data;
                        var responseTraineeCrewIds = responseTrainees.map(function(trainee){return trainee.CrewId});
                        $scope.traineeInfo = trainees.filter(x => responseTraineeCrewIds.includes(x.CrewId));
                    }
                    else{
                        $scope.errorMessage = null;
                    }

                    if(dutyId){ //isGround
                        TrainingSessionFactory.remove(courseId,date,dutyId);
                        GroundDutyFactory.setCourseCompleted(dutyId,courseId);
                    }
                    else{   //isFlight
                        FlightSessionFactory.remove(courseId, date, dutyNo, dutyDay);
                        CrewRouteFactory.setCourseCompleted(dutyNo, dutyDay, courseId, date)
                    }

                    CourseFactory.setCourseOutdated(courseId);
                    $scope.success = true;
                }).catch(function(data){
                    $scope.isLoading = false;
                    if(data.data && data.data.errorMessage){
                        $scope.errorMessage = data.data.errorMessage;
                    }
                    else{
                        $scope.errorMessage = "Failed to save Training Session";
                    }
                });    
            }

            // clear password
		    $scope.formData.password = "";
        }

        /**
         * Close the modal
         * @memberof SignModalCtrl
         */
        function close(){
            var result = {
                "success" : $scope.success
            };
            $uibModalInstance.close(result);
        }
    }
})();